<template>
  <div class="xero-wrap xero-wrap-mobile">
    <div class="logo"></div>
    <div class="clear">
        <div class="pro">
            <template v-if="venueReg.isPro">
              <div class="tit">1 / 3</div>
              <el-progress :percentage="33"></el-progress>
            </template>

            <template v-if="!venueReg.isPro">
              <div class="tit">1 / 2</div>
              <el-progress :percentage="50"></el-progress>
            </template>
        </div>
    </div>
    <div class="title">Register Peiso</div>
    <div class="bgd">
      <div class="con">
        <h1 class="title">General Information</h1>
        <h2><i style="font-style:normal;color:red">*</i> Venue Name</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['name']}" @blur="validateInput('name')" type="text" v-model="name" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:red">*</i> Venue Owner</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['owner']}" @blur="validateInput('owner')" type="text" v-model="owner" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:red">*</i> Mobile Number</h2>
        <div class="inputItem">
          <input type="text" :class="{'border-error': validationInputError['number']}" @blur="validateInput('number')" v-model="number" @input="validate('number')" :maxlength="11" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:red">*</i> Email</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['emailAddress']}" @blur="validateInput('emailAddress')" type="emailAddress" v-model="emailAddress" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <!-- <h2><i style="font-style:normal;color:red">*</i> ABN</h2>
        <div class="inputItem" style="position:relative">
          <span v-if="warn" style="position:absolute;left:0;top:55px;color:rgb(242 0 20);font-size:12px">Please enter an 11-digit ABN</span>
          <input type="text" @blur="
          if (abn.length < 11)
            warn = true
          else
            warn = false" :style="{'border-color': warn ? 'rgb(242 0 20)' : 'var(--background-color-4)'}" v-model="abn" @input="validate('abn')" maxlength="11" @change="validateComplete" />
        </div> -->
        <h2><i style="font-style:normal;color:red">*</i> Venue Description</h2>
        <div class="checkboxItem clear">
          <el-checkbox-group v-model="check" @change="cheboxChange" class="check-description">
            <el-checkbox label="Bar"></el-checkbox>
            <el-checkbox label="Café"></el-checkbox>
            <el-checkbox label="Restaurant"></el-checkbox>
          </el-checkbox-group>
          <el-select v-model="slt" v-if="sltShow">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <h2><i style="font-style:normal;color:red">*</i> Cuisine Type</h2>
        <div class="typeItem clear">
          <div class="add" @click="openCuisine">
            <i class="el-icon-circle-plus-outline"></i>
            Add Type
          </div>
          <div class="items-container">
            <div class="item" v-for="item in typeList" :key="item">{{item}}<i @click="removeCurrent(item)"></i></div>
          </div>
        </div>
        <h2><i style="font-style:normal;color:red">*</i> Venue Address</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['address']}" @blur="validateInput('address')" type="text" v-model="address" @input="validateComplete" maxlength="100" />
        </div>
        <template v-if="instance_type != 'lucas'">
          <h2><i style="font-style:normal;color:red">*</i> Venue Timezone</h2>
          <div class="inputItem">
            <el-select
              v-model="timezone"
              filterable
              :default-first-option="true"
              :class="{'border-error': validationInputError['timezone']}"
              class="select-input"
              placeholder="Select"
              @blur="validateInput('address')"
              @input="validateComplete" 
              @change="validateComplete"
            >
              <el-option
                v-for="item in timezoneList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </template>
        <!-- <h2>Instagram Username</h2>
        <div class="inputItem">
          <input type="text" v-model="ins" maxlength="100" />
        </div>
        <h2>Facebook Page</h2>
        <div class="inputItem">
          <input type="text" v-model="face" maxlength="100" />
        </div> -->
        <h2><i style="font-style:normal;color:red">*</i>Username <span style="margin-left: 5px;">(please create your Username)</span></h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['username']}" @blur="validateInput('username')" @input="validateComplete" type="text" v-model="username" maxlength="30" />
        </div>
        <h2><i style="font-style:normal;color:red">*</i>Password <span style="margin-left: 5px;">(please create your Password)</span></h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['password']}" @blur="validateInput('password')" @input="validateComplete" type="password" v-model="password" maxlength="16" />
        </div>

        <div class="btm-btns clear d-flex justify-content-center">
          <button class="confirm" @click="confirm">Next</button>
        </div>
      </div>
    </div>
    <transition name="fade" v-if="pop">
      <cuisine @eventCacncel="closeCuisine" @eventConfirm="getCuisinetype" :checked="typeString"></cuisine>
    </transition>

  </div>
</template>

<script>
import cuisine from '../common/cuisine.vue'
import api from '../../api/xero'
import venueApi from '../../api/venue'
import discount from '@/api/discount';
import utils from '../../utils/utils';

var ifRestart = false
export default {
  data () {
    return {
      name: '',
      owner: '',
      number: '',
      emailAddress: '',
      abn: '',
      warn: false,
      // Venue Description test
      check: [],
      // Cuisine Type
      typeList: [],
      timezoneList: [],
      typeString: '',
      address: '',
      timezone: '',
      web: '',
      ins: '',
      face: '',
      username: '',
      password: '',
      // Venue Description是否显示下拉框
      sltShow: false,
      // Venue Description选的下拉框
      slt: 'Fast Food',
      options: [{
        value: 'Fast Food',
        label: 'Fast Food'
      }, {
        value: 'Quick Service',
        label: 'Quick Service'
      }, {
        value: 'Fast Casual',
        label: 'Fast Casual'
      }, {
        value: 'Fine Dining ',
        label: 'Fine Dining '
      }],
      // 是否打开选择的弹窗
      pop: false,
      // 是否输入完整
      isComplete: false,
      validationInputError: {
        name: false,
        owner: false,
        number: false,
        address: false,
        timezone: false,
        username: false,
        password: false,
        emailAddress: false,
      },
      venueReg: JSON.parse(sessionStorage.getItem('request_params')),
      discountCode: '',
      isErrorDiscount: false,
      instance_type: process.env.INSTANCE_TYPE,
      errorMessages: '',
    }
  },
  async mounted() {
    if (!sessionStorage.getItem('request_params')) {
      this.$router.replace('/welcome')
    } else {
      var register = JSON.parse(sessionStorage.getItem('request_params'))
      if (register.venueName) {
        this.name = register.venueName
        this.owner = register.venueOwner
        this.number = register.venueMobile
        this.timezone = register.timezone
        this.abn = register.abn
        this.ins = register.instagramUsername
        this.username = register.userName
        this.password = register.password
        this.address = register.venueAddress
        this.emailAddress = register.emailAddress
        this.typeList = register.cuisineType ? register.cuisineType.split(",") : []

        if (register.cuisineType) {
          var checked = register.venueDescription.split(",")
          checked = checked.map((n) => {
            return n == 'Cafe' ? 'Café' : n
          })

          this.check = checked
        }


        this.validateComplete()
      }

      if (this.instance_type != 'lucas') {

        const timezones = await venueApi.getTimezoneList();
        if (timezones && timezones.length > 0) {
          this.timezoneList = timezones.map(item => ({
            value: item,
            label: item
          }))
        }
      }

    }
    if (this.$route.query.code) {
      api.getProfileInfo({
          params: {code: this.$route.query.code},
          // params: formData,
          callback: (res) => {
              if (res.data.code == 0) {
                  this.username = res.data.data.userName ? res.data.data.userName : ''
                  this.owner = res.data.data.venueOwner ? res.data.data.venueOwner : ''
              } else {
                  Utils.alert2('', res.data.message ,'error')
              }
          }
      })
    }
  },
  created() {

  },
  methods: {
    validateInput(modelName) {window.Utils
      const model = typeof(this[modelName]) === 'number' ? JSON.stringify(this[modelName]) : this[modelName];
      if (model.replace(/\s+/g,'') === '') {
        this.validationInputError[modelName] = true;
      } else {
        this.validationInputError[modelName] = false;
      }
    },

    addTime(val){
      this.addTimeDay=val.week
      this.addTimeDio=true
    },
    resetTime(e) {
      this.tableData[e].time = ''
    },
    addTimed(val){
      // 找到对应的星期，设置时间，获取为设置的天数
      let num = 0
      let temp = ''
      this.tableData.forEach(item=>{
          if(item.week == this.addTimeDay){
            if(item.time !== '') {
              let arr = item.time.split(',')
              arr.push(val)
              item.time = arr.join(',')
            } else {
              item.time = val
            }
            temp = item.time
          } else {
            if (item.time === '')
              num ++
          }
      })
      // 重新遍历一次
      console.log(num)
      if (num === 6) {
        this.tableData.forEach(item => {
          if (item.time === '') {
            item.time = temp
          }
        })
      }
      this.addTimeDio = false
      this.validateComplete()
    },
    // 多选框变化选中
    cheboxChange (val) {
      console.log(val)
      if (val.includes('Restaurant')) {
        this.sltShow = true
      } else {
        this.sltShow = false
      }
      this.validateComplete()
    },
    // 移除type
    removeCurrent (name) {
      var that = this
      that.typeList.find((v, i) => {
        if (v == name) {
          that.typeList.splice(i, 1)
          that.validateComplete()
        }
      })
    },
    // 新增type，打开弹窗，并把现有的type传过去
    openCuisine () {
      var that = this
      that.pop = true
      if (that.typeList.length > 0) {
        that.typeString = that.typeList.join(',')
      }
    },
    // 取消新增
    closeCuisine () {
      this.pop = false
    },
    // 拿到新增的type，关闭弹窗
    getCuisinetype (type) {
      var that = this
      that.pop = false
      if (type == '') {
        that.typeList = []
        that.typeString = ''
        this.validateComplete()
        return
      }
      const addLst = type.split(',')
      that.typeList = addLst
      that.typeString = that.typeList.join(',')
      this.validateComplete()
    },
    validate (type) {
      var that = this
      if (type === 'number') {
        this.number = this.number.replace(/[^\d]/g,'')
        that.validateComplete()
      }
      // else if (type === 'abn') {
      //   this.abn = this.abn.replace(/[^\d]/g,'')
      //   that.validateComplete()
      // }
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    validateComplete(e, type) {
      const validations = {
        name: () => {
          const value = this.name.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Venue name is required' : '';
          return value !== '';
        },
        owner: () => {
          const value = this.owner.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Venue owner is required' : '';
          return value !== '';
        },
        number: () => {
          const value = this.number.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Mobile number is required' : '';
          return value !== '';
        },
        emailAddress: () => {
          const isValid = this.emailAddress !== '' && this.validateEmail(this.emailAddress);
          this.errorMessages = !isValid ? 'Please enter a valid email address' : '';
          return isValid;
        },
        address: () => {
          const value = this.address.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Venue address is required' : '';
          return value !== '';
        },
        timezone: () => {
          const isValid = this.timezone !== '';
          this.errorMessages = !isValid ? 'Timezone is required' : '';
          return isValid;
        },
        username: () => {
          const value = this.username.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Username is required' : '';
          return value !== '';
        },
        password: () => {
          const value = this.password.replace(/\s+/g,'');
          this.errorMessages = value === '' ? 'Password is required' : '';
          return value !== '';
        },
        venueDescription: () => {
          const isValid = this.check.length !== 0;
          this.errorMessages = !isValid ? 'Please select at least one venue description' : '';
          return isValid;
        },
        cuisineType: () => {
          const isValid = this.typeList.length !== 0;
          this.errorMessages = !isValid ? 'Please add at least one cuisine type' : '';
          return isValid;
        }
      };

      // Run all validations
      const isValid = Object.values(validations).every(validation => validation());
      this.isComplete = isValid;
    },
    confirm() {

      this.validateComplete();

      let arr = []
      this.check.forEach(item => {
        if (item === 'Bar') {
          arr.push('Bar')
        } else if (item === 'Café') {
          arr.push('Cafe')
        } else if (item === 'Restaurant') {
          arr.push(this.slt)
        }
      })
      const venueDescription = arr.join(',')
      var register = JSON.parse(sessionStorage.getItem('request_params'))

      let request_params = {
        abn: this.abn, // 必填
        cuisineType: this.typeList.join(','), // 必填
        instagramUsername: this.ins === '' ? null : this.ins,
        venueAddress: this.address, // 必填
        timezone: this.timezone, // 必填
        venueDescription: venueDescription, // 必填
        venueMobile: this.number, // 必填
        venueName: this.name, // 必填
        venueOwner: this.owner, // 必填
        emailAddress: this.emailAddress,
        password: this.password,
        userName: this.username, // 必填

        venueOpenAddVoList: [
          {
            week: "Monday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Tuesday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Wednesday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Thursday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Friday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Saturday",
            openTime: "09:00 am - 06:00 pm"
          },
          {
            week: "Sunday",
            openTime: "09:00 am - 06:00 pm"
          },
        ],
        isPro: register.isPro
      }

      if (this.isComplete) {
        if (this.face.replace(/^\./g,'') !== '')
          request_params.facebookPage = this.face
        else
          request_params.facebookPage = null
          sessionStorage.setItem('request_params', JSON.stringify(request_params))

          this.$router.replace('/mobileApp')
      } else {
        utils.alert2('Error', this.errorMessages, 'error')
      }

     
    },
  },
  components:{
    cuisine
  },
  /*activated() {
		//keepAlive组件激活才会触发的钩子，用于重新获取数据进而保存更新的缓存
    if(ifRestart){
      sessionStorage.removeItem('request_params')
      this.name = ''
      this.owner = ''
      this.number = ''
      this.abn = ''
      this.warn = false
      this.check = []
      this.typeList = []
      this.typeString = ''
      this.address = ''
      this.web = ''
      this.ins = ''
      this.face = ''
      this.username = ''
      this.password = ''
      this.sltShow = false
      this.isComplete = false
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/welcome') {
      ifRestart = true
    } else {
      ifRestart = false
    }
    next()
  }*/
}
</script>

<style lang="scss">
@import 'static/scss/media-queries';
@import 'static/scss/fonts/fonts';
.xero-wrap{
  color: var(--text-color);
  padding-bottom: 50px;
  min-width: 1200px;
  .bgd{
    width: 100%;
    background: var(--background-color-4);
    padding: 50px 0 65px 0;
    //margin-bottom: 50px;
    .con{
      width: 740px;
      margin: 0 auto;
      .btm-btns{
        width: 100%;
        margin: 65px auto 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          float: left;
          box-sizing: border-box;
          font-size: 26px;
          cursor: pointer;
        }
        .confirm{
          border: 2px solid #EA3796;
          font-weight: 700;
          color: #EA3796;
        }
        .disabled{
          border: 2px solid #8E3771;
          color: #8E3771;
          cursor: not-allowed;
        }
      }
      h1{
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .inputItem{
        width: 100%;
        margin-bottom: 30px;
        position: relative;
        input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: var(--background-color-2);
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--text-color);
          height: 50px;
        }
        .lft{
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
        .rgt{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
      }
      .checkboxItem{
        margin-bottom: 44px;
      }
      .singleItem{
        width: 355px;
      }
      .singleItem:nth-child(1){
        float: left;
      }
      .singleItem:nth-child(2){
        float: right;
      }
      .btns{
        width: 100%;
        box-sizing: border-box;
        padding-left: 16px;
        div{
          float: left;
          line-height: 60px;
          cursor: pointer;
        }
        .add{
          margin-right: 32px;
        }
        .reset{
          color: #EA3796;
        }
      }
      .timlst{
        width: 100%;
        span{
          display: block;
          float: left;
          line-height: 25px;
          i{
            font-style: normal;
          }
        }
      }
    }

  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .new_box{
    display: flex;
    .inputItem{
      flex: 1;
    }
    .inputItemNew{
      margin-right: 30px;
    }
  }

}

.select-input{
  width: 100% !important;
}
.typeItem{
  width: 100%;
  .add{
      float: left;
      width:150px;
      height:50px;
      border:1px solid rgba(234,55,150,1);
      line-height:50px;
      color: #EA3796;
      font-size: 20px;
      padding-left: 46px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      margin-right: 30px;
      margin-bottom: 30px;
      i{
      font-size: 20px;
      position: absolute;
      left: 16px;
      top: 15px;
      }
  }
  .item{
      height:50px;
      background:rgba(21,28,39,1);
      border:1px solid rgba(95,95,95,1);
      float: left;
      margin-right: 30px;
      padding: 0 20px;
      font-size: 20px;
      line-height: 50px;
      color: var(--text-color);
      cursor: pointer;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 30px;
      i{
      display: block;
      width: 20px;
      height: 20px;
      position:absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url('../../assets/g.png');
      }
  }
}
.pro{
    margin-bottom: 30px;
    width: 200px;
    float: right;
    .tit{
        text-align: right;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #EA3796;
        line-height: 22px;
    }
}
.title{
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: var(--text-color);
    line-height: 33px;
    margin-bottom: 39px;
}

.border-error {
  border-color: #f20014 !important;
}

.error-message {
  display: block;
  color: #f20014;
  font-size: 12px;
  margin-top: 5px;
  font-family: 'SFProText-Regular';
}
</style>



// WEBPACK FOOTER //
// src/components/register/general.vue